const config = {
  BASE_URL: `/api`
  // BASE_URL: `http://localhost:4000/api`
  // BASE_URL: `http://206.189.202.169:4000/api`
};

export default config;



// WEBPACK FOOTER //
// ./src/libs/config.js